import _objectSpread2 from '../node_modules/@babel/runtime/helpers/esm/objectSpread2.js';
import '../node_modules/core-js/modules/es.array.reduce.js';
import '../node_modules/core-js/modules/es.string.trim.js';
import { isString } from './common.js';

const defaultSettings = {
  el: '__',
  mod: '_',
  modValue: '_',
  prefix: 'rcl__'
};
const isBemMods = nameOrMods => typeof nameOrMods !== 'string';

/**
 * Add new mixes to context of the block
 * @param context
 * @param settings
 */
const mix = function mix(context) {
  let settings = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultSettings;
  return function () {
    const copiedContext = _objectSpread2({}, context);
    for (var _len = arguments.length, mixes = new Array(_len), _key = 0; _key < _len; _key++) {
      mixes[_key] = arguments[_key];
    }
    copiedContext.mixes = copiedContext.mixes.concat(mixes);
    return createBemItem(copiedContext, settings);
  };
};

/**
 * Create a string from context according to BEM rules
 * @param context
 * @param settings
 */
const toString = (settings, context) => {
  const {
    name,
    mods,
    mixes
  } = context;
  let classes = [name];

  // Add list of modifiers
  if (mods) {
    classes = classes.concat(Object.keys(mods).filter(key => mods[key]) // Don't add modifiers with falsy values
    .map(key => {
      const value = mods[key];
      // Modifier with only name
      if (value === true) {
        return name + settings.mod + key;
      }
      return name + settings.mod + key + settings.modValue + value;
    }));
  }

  // Add mixes
  if (mixes) {
    classes = classes.concat(mixes);
  }
  return classes.join(' ');
};

/**
 * Create an object BemItem,
 * with method mix and custom string representation
 * @param context
 * @param settings
 */
function createBemItem(context, settings) {
  return {
    mix: mix(context, settings),
    toString: toString.bind(null, settings, context)
  };
}

/**
 * Bounds an element name and mods,
 * Return a function that generates class names for components
 * @param context
 * @param settings
 */
const createBemBlock = function createBemBlock(context) {
  let settings = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultSettings;
  return function () {
    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }
    if (!args.length) {
      return createBemItem(context, settings);
    }
    const copiedContext = _objectSpread2({}, context);
    copiedContext.name = args.filter(isString).reduce((acc, name) => acc + settings.el + name, copiedContext.name);
    copiedContext.mods = args.filter(isBemMods).reduce((acc, mods) => _objectSpread2(_objectSpread2({}, acc), mods), copiedContext.mods);
    return createBemItem(copiedContext, settings);
  };
};

/**
 * Bounds a block name
 * Return a function that generates a block wrapper
 * @param blockName
 * @param settings
 */
const block = function block(blockName) {
  let settings = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultSettings;
  if (!blockName.trim()) {
    throw new Error('Block name should be non-empty');
  }
  const completeSettings = _objectSpread2(_objectSpread2({}, defaultSettings), settings);
  const name = completeSettings.prefix + blockName.trim();
  const context = {
    name,
    mods: {},
    mixes: []
  };
  const boundBlock = createBemBlock(context, completeSettings);
  boundBlock.mix = mix(context, completeSettings);
  return boundBlock;
};

export { block, createBemBlock };
